<template lang="pug">
  .window-details
    RadioSlider(:items="actionTypes.items", :current="currentActionType", @selected="changeAction")

    .create-baixa(v-if="actionTypes.selected.id === 'baixa'")
      h4 adicionar nova baixa de banco de horas
      .add
        PDatePicker(name="datebaixa", label="data da baixa" v-model="baixa.date", required)
        PDatePicker(name="datepayment", label="data de pagamento da baixa" v-model="baixa.dateBalance", required)

        .button
          PButton(color="success" size="sm" block @click="createBaixa" :loading="creatingBaixa") adicionar baixa

      .flags
        .flags__checkbox
          PCheckbox(name="ultimoDiaInclusive", label="Considerar (inclusive) a data de baixa no cálculo da baixa de banco de horas" v-model="baixa.ultimoDiaInclusive")
        .flags__icone-de-informacao.icon-ptt-icons-info(style="font-size: 22px;")

        uiv-popover(
          target=".flags__icone-de-informacao"
          trigger="hover"
          placement="top"
        )
          div(slot="popover")
            span Ao selecionar essa opção, os eventos que acontecerem na data da baixa de banco de horas serão considerados no pagamento da baixa. Caso contrário será considerado apenas até o dia anterior

      hr
      h4 histórico de baixas de banco de horas
      .existing-baixas
        div
          b data
          b data de compensação
          b compensado
          b

        template(v-if="baixa.baixas.loaded.length")
          div(v-for="(b, index) in baixa.baixas.loaded")
            span {{ b.date }}
            span {{ b.compensation_date || b.dateCompensated }}
            span {{ b.compensation.allTimes }}
            PButton(color="danger", size="sm" block @click="removerBaixa(b)"
              v-if="index === baixa.baixas.loaded.length - 1" :loading="removingBaixa") remover baixa

        div(v-else-if="baixa.baixas.loading" style="grid-column: 1/5") carregando
        div(v-else style="grid-column: 1/5") nenhuma baixa encontrada

    .create-debito-credito(v-if="actionTypes.selected.id === 'createCreditoDebito'")
      PDatePicker(name="date", label="data" v-model="debitoCredito.compensationDate", required)

      .flex
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.delayTime" label="horas de atraso")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.earlyExit" label="saída antecipada")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.lunchPenalty" label="excesso de pausa")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.absenceHours" label="horas de falta")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTime50Tot" label="hora extra")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTime50NotTot" label="hora extra not.")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTime100Tot" label="h.e extraordinária")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTime100NotTot" label="h.e. extraordinária not.")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTimeSpecialTot" label="hora extra especial")
        PInputHourMinute(name="lunchDur" v-model="debitoCredito.extraTimeSpecialNotTot" label="hora extra especial not.")

      PCheckbox(v-model="debitoCredito.isPartialBaixa" label="considerar como baixa parcial")

      .buttons
        PButton(color="success", size="md" block @click="createDebitoCredito" :loading="creatingBaixa") criar

</template>

<script>
import moment from 'moment'
import DBLabel from 'src/common/SmartTable/DBLabel'

export default {
  name: 'WindowDetails',
  components: {DBLabel},
  props: {
    item: {type: Object, required: true}
  },
  created () {
    this.actionTypes.selected = this.actionTypes.items[0]
    this.fetchBaixas()
  },
  data () {
    return {
      canAddBaixa: this.$hasPermission({module: 'workhourbankcloser', action: 'post', hide: true}),
      actionTypes: {
        selected: null,
        items: [
          {id: 'baixa', name: 'baixas de banco de horas'},
          {id: 'createCreditoDebito', name: 'criar débito e crédito'}
        ]
      },
      debitoCredito: {
        compensationDate: new Date(),
        isPartialBaixa: false,
        extraTime50Tot: {float: 0, hours: 1, minutes: 0},
        extraTime100Tot: {float: 0, hours: 1, minutes: 0},
        extraTimeSpecialTot: {float: 0, hours: 1, minutes: 0},
        extraTime50NotTot: {float: 0, hours: 1, minutes: 0},
        extraTime100NotTot: {float: 0, hours: 1, minutes: 0},
        extraTimeSpecialNotTot: {float: 0, hours: 1, minutes: 0},
        delayTime: {float: 0, hours: 1, minutes: 0},
        earlyExit: {float: 0, hours: 1, minutes: 0},
        lunchPenalty: {float: 0, hours: 1, minutes: 0},
        absenceHours: {float: 0, hours: 1, minutes: 0}
      },
      baixa: {
        date: new Date(),
        dateBalance: new Date(),
        ultimoDiaInclusive: false,
        baixas: {
          loading: false,
          loaded: [],
          selected: null
        }
      },
      creatingBaixa: false,
      removingBaixa: false,
      mensagemAjuda: 'Ao selecionar essa opção, os eventos que acontecerem na data da baixa de banco de ' +
      'horas serão considerados no pagamento da baixa. Caso contrário, serão considerados os eventos que acontecerem até o dia anterior a baixa.'
    }
  },
  computed: {
    currentActionType () {
      return this.actionTypes.items.findIndex(i => i.id === this.actionTypes.selected.id)
    }
  },
  methods: {
    changeAction (item) {
      this.actionTypes.selected = item
    },
    async fetchBaixas () {
      this.baixa.baixas.loading = true
      this.baixa.baixas.loaded = []
      const result = await this.$API.whbCloser.get({employeeId: this.item.employee.id})
      this.baixa.baixas.loaded = (result.data?.success || []).map(i => {
        return {
          ...i,
          date: moment(i.date).format('DD/MM/YYYY'),
          dateCompensated: moment(i.dateCompensated).format('DD/MM/YYYY'),
          compensation_date: moment(i.compensation.date).format('DD/MM/YYYY')
        }
      })
      if (this.baixa.baixas.loaded.length) {
        this.baixa.baixas.selected = this.baixa.baixas.loaded[0]
      } else {
        this.baixa.baixas.selected = null
      }
      this.baixa.baixas.loading = false
    },
    async createBaixa () {
      this.creatingBaixa = true
      try {
        await this.$API.whbCloser.save({
          employeeId: this.item.employee.id,
          date: moment(this.baixa.date).format('YYYY-MM-DD'),
          dateBalance: moment(this.baixa.dateBalance).format('YYYY-MM-DD')
        }, {
          ultimoDiaInclusive: this.baixa.ultimoDiaInclusive
        })
        this.fetchBaixas()
        this.$emit('updateMonth')
        this.$modalDeSucesso('Baixa adicionada com sucesso')
      } catch (e) {
        this.$modalDeErro(
          e.data.error || 'Não foi possível adicionar a baixa de banco'
        )
      }
      this.creatingBaixa = false
    },
    async removerBaixa (baixa) {
      this.removingBaixa = true
      try {
        await this.$API.whbCloser.delete({id: baixa.id}, {})
        this.fetchBaixas()
        this.$emit('updateMonth')
      } catch (e) {
        this.$swal({
          type: 'error',
          title: 'Aconteceu um erro',
          text: e.data || 'Não foi possível remover a baixa de banco'
        })
      }
      this.removingBaixa = false
    },
    async createDebitoCredito () {
      try {
        this.creatingBaixa = true
        await this.$API.whboCreate.save({kind: 'add'}, {
          date: moment(this.debitoCredito.compensationDate).format('YYYY-MM-DD'),
          employee: this.item.employee.id,
          kind: 'add',
          isArbitrary: true,
          isTms: this.debitoCredito.isPartialBaixa,
          extraTime50Tot: this.debitoCredito.extraTime50Tot.float,
          extraTime100Tot: this.debitoCredito.extraTime100Tot.float,
          extraTimeSpecialTot: this.debitoCredito.extraTimeSpecialTot.float,
          extraTime50NotTot: this.debitoCredito.extraTime50NotTot.float,
          extraTime100NotTot: this.debitoCredito.extraTime100NotTot.float,
          extraTimeSpecialNotTot: this.debitoCredito.extraTimeSpecialNotTot.float,
          delayTime: this.debitoCredito.delayTime.float,
          earlyExit: this.debitoCredito.earlyExit.float,
          lunchPenalty: this.debitoCredito.lunchPenalty.float,
          absenceHours: this.debitoCredito.absenceHours.float
        })
        this.$emit('updateMonth')
        this.$swal({
          type: 'success',
          text: 'Crédito/débito criado com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          title: 'Aconteceu um erro',
          text: e.data.error || 'Não foi possível criar o crédito/débito'
        })
      }
      this.creatingBaixa = false
    }
  },
  filters: {
    date (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>

<style scoped lang="scss">
.window-details {

  .create-baixa {
    display: grid;
    padding-top: 30px;

    .add {
      display: grid;
      grid-template-columns: 300px 300px max-content;
      grid-column-gap: 10px;

      .button {margin-bottom: 13px}

      > div {
        align-self: baseline;
      }

    }

    .flags {
      display: flex;

      &__icone-de-informacao {
        margin-left: 1rem
      }
    }

    .existing-baixas {
      max-height: 300px;
      overflow-y: auto;

      div {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        margin: 2px 0 2px 0;
        padding: 2px;
        border-bottom: 1px solid lightgrey;
      }
    }
  }

  .create-debito-credito {
    display: grid;
    padding-top: 30px;

    .flex {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 2px;
    }

    .buttons {
      display: grid;
      width: fit-content;
      grid-template-columns: 1fr;
      justify-self: right;
    }
  }
}
</style>
